<template>
    <div class="u-tac">
        <img src="../assets/not-found.svg" alt="Greška 404 - Strana ne postoji" class="not-found-img">
        <h1>Грешка 404</h1>
        <p>Тражена страна не постоји. Вратите се на <a href="/">почетну страну</a>.</p>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .not-found-img {
        fill: blue;
    }
</style>
